import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { ICity } from "@/shared/types/city";
import type { IBusStation } from "@/shared/types/busStaition";
import { RootState } from "@/store/redux/store";
import { setBusStation, setBusStationTo, setCity, setCityTo } from "../store/mapScreenSlce";

type Params = {
    city?: ICity | null;
    busStation?: IBusStation | null;
    cityTo?: ICity | null;
    busStationTo?: IBusStation | null;

    /**
     * Если true — при очистке/смене "Куда" будем сбрасывать "Откуда".
     * Обычно лучше false (UX мягче), но ты можешь включить.
     */
    resetFromOnResetTo?: boolean;

    /**
     * Коллбэк, чтобы понять: была ли busStation выбрана
     * “в рамках маршрута к конкретной busStationTo”.
     * Если не нужно — можно не передавать.
     */
    shouldResetFromOnToClear?: (prev: {
        city?: ICity | null;
        busStation?: IBusStation | null;
        cityTo?: ICity | null;
        busStationTo?: IBusStation | null;
    }) => boolean;
};

export function useFormResetSync({
    // city,
    // busStation,
    // cityTo,
    // busStationTo,
    resetFromOnResetTo = false,
    shouldResetFromOnToClear,
}: Params) {

    const {
        city,
        cityTo,
        busStation,
        busStationTo,
    } = useSelector((state: RootState) => state.mapScreen);

    const dispatch = useDispatch();

    const prevRef = useRef({
        city: city ?? null,
        busStation: busStation ?? null,
        cityTo: cityTo ?? null,
        busStationTo: busStationTo ?? null,
    });

    useEffect(() => {
        const prev = prevRef.current;

        const prevCityId = prev.city?.id?.toString();
        const cityId = city?.id?.toString();

        const prevBusFromId = prev.busStation?.id?.toString();
        const busFromId = busStation?.id?.toString();

        const prevCityToId = prev.cityTo?.id?.toString();
        const cityToId = cityTo?.id?.toString();

        const prevBusToId = prev.busStationTo?.id?.toString();
        const busToId = busStationTo?.id?.toString();

        const isChangeCityIdFrom = prevCityId !== cityId;
        const isChangedBusStaitionFrom = prevBusFromId !== busFromId;
        const isChangedCityIdTo = prevCityToId !== cityToId;

        /** 1) Смена города "Откуда" => сбрасываем "Куда" полностью */
        if (isChangeCityIdFrom) {
            // Если город "откуда" очистили или поменяли — "куда" становится невалидным
            dispatch(setCityTo());
            dispatch(setBusStationTo());

            // Опционально: при смене города откуда сбрасывать и ОП откуда:
            dispatch(setBusStation(null));
        }

        /** 2) Смена ОП "Откуда" => сбрасываем "Куда" полностью */
        if (isChangedBusStaitionFrom && isChangedCityIdTo && isChangeCityIdFrom) {
            console.log(777, prevBusFromId, busFromId)
            dispatch(setCityTo());
            dispatch(setBusStationTo());
        }

        /** 3) Смена города "Куда" => сбрасываем только ОП "Куда" */
        if (isChangedCityIdTo) {
            dispatch(setBusStationTo(null));
        }

        /** 4) Смена/очистка ОП "Куда" */
        if (prevBusToId !== busToId) {
            const wasTo = Boolean(prev.busStationTo);
            const isToNow = Boolean(busStationTo);

            // Очистили ОП "Куда"
            if (wasTo && !isToNow) {
                const needResetFrom =
                    resetFromOnResetTo ||
                    (shouldResetFromOnToClear ? shouldResetFromOnToClear(prev) : false);

                if (needResetFrom) {
                    // TODO:
                    // dispatch(setBusStation(null));
                    // dispatch(setCity(null));
                }
            }
        }

        prevRef.current = {
            city: city ?? null,
            busStation: busStation ?? null,
            cityTo: cityTo ?? null,
            busStationTo: busStationTo ?? null,
        };
    }, [city, busStation, cityTo, busStationTo, dispatch, resetFromOnResetTo, shouldResetFromOnToClear]);
}